import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export default function SelectOptionBox(props) {
  const { 
    index,
    selectOptionGroupIndex,
    selectOptions,
    onClickSelectOption
  } = props;

  const { t } = useTranslation();

  // 옵션박스 너비 조절 //
  function decideOptionBoxWidth() {
    // if (souvenirData !== undefined && souvenirData.size !== undefined) {
    if (selectOptions !== undefined) {
      if (selectOptions.length === 1) return 'calc(100% - 4px)';
      else if (selectOptions.length === 2) return 'calc(48% - 4px)';
      else return 'calc(30% - 4px)';
      // return 'calc(48% - 4px)';
    }
    else return '0px';
  }


  return (
    <TopLevelWrapper>
      <TotalWrapper>
        <LayerWrapper>
          {
            selectOptions.map((optionData, optionIndex) => (
              <InfoBox
                key={'OptionBox-' + optionIndex}
                width={decideOptionBoxWidth()}
                isSelected={optionData.isClicked} 
                onClick={() => onClickSelectOption(index, selectOptionGroupIndex, optionIndex)}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={optionData.isClicked ? '#F9F9F9' : '#595959'}>{optionData.name}</Text>
              </InfoBox>
            ))
          }
        </LayerWrapper>
      </TotalWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: space-between;
  // justify-content: flex-start;
  align-items: center;

  width: 100%;
  gap: 10px;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 8px;

  // width: calc(30% - 4px);
  width: ${props => props.width};
  height: 36px;

  border: ${props => props.isSelected ? '2px solid #6DD49E' : '2px solid #E0E0E0'};
  border-radius: 8px;
  background-color: ${props => props.isSelected ? '#6DD49E' : '#F9F9F9'};

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  padding: 0 0 0 0;
  margin: 0 0 0 0;

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;